import { Component, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input-general-calendar',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-general-calendar.component.html',
})
export class InputGeneralCalendarComponent {
  private translate = inject(TranslateService);

  formControlGeneral = input<FormControl | AbstractControl | null>(new FormControl());
  placeholder = input('DD/MM/YYYY');
  label = input('');
  min = input<null | Date>(null);

  get getInputGeneral(): FormControl {
    return this.formControlGeneral() as FormControl;
  }

  isRequired(): boolean {
    return !!this.formControlGeneral()?.hasValidator?.(Validators.required);
  }

  hasErrorState(): boolean {
    const ctrl = this.formControlGeneral();
    return !!ctrl && ctrl.invalid && (ctrl.touched || ctrl.dirty);
  }

  getErrorMessage(): string {
    const control = this.formControlGeneral();
    if (!control || !control.errors) return '';

    const errors = control.errors;

    if (errors['required']) {
      return this.translate.instant('inputs.required');
    }
    if (errors['minlength']) {
      return this.translate.instant('inputs.minlength', { requiredLength: errors['minlength'].requiredLength });
    }
    if (errors['maxlength']) {
      return this.translate.instant('inputs.maxlength', { requiredLength: errors['maxlength'].requiredLength });
    }
    if (errors['min']) {
      return this.translate.instant('inputs.min', { min: errors['min'].min });
    }
    if (errors['max']) {
      return this.translate.instant('inputs.max', { max: errors['max'].max });
    }
    if (errors['pattern']) {
      return this.translate.instant('inputs.invalidFormat');
    }

    return '';
  }
}
